import React, { useContext, useEffect, useRef, useState } from 'react';
import { CustomDropdownWrapper } from './style';

import { clickOutside, getLocation, isEmpty } from '../../utils/common';
import { GlobleContaxt } from '../../Context/GlobleContaxt';
import Input from '../UIbox/Input';

const CustomDropdown = ({ list, setProvider, setMessage, type, provider = '', accessLoaction = true }) => {
	const [searchQuery, setSearchQuery] = useState('');

	const [listShow, setListShow] = useState(false);
	const [isActive, setIsActive] = useState('');
	const { geolocation, setGeolocation, setAlert } = useContext(GlobleContaxt);
	const handleSearchChange = (e) => {
		if (isEmpty(localStorage.getItem('ID Token'))) {
			setAlert({ type: 'error', msg: 'Please login first to continue' });

			return;
		}

		setSearchQuery(e.target.value);
	};

	const handleOptionSelect = (value, name) => {
		setIsActive(name);

		setSearchQuery(name);
		setProvider(value);
		setListShow(false);
	};
	useEffect(() => {
		if (provider === '') {
			setSearchQuery('');
		}
	}, [provider]);

	const blur = () => {
		
	};

	const handalFocus = () => {
		if (isEmpty(localStorage.getItem('ID Token'))) {
			setAlert({ type: 'error', msg: 'Please login first to continue' });

			return;
		}

		if (isEmpty(geolocation?.latitude)) {
			setAlert({ type: 'warning', msg: 'Please allow access to your location' });

			getLocation().then((position) => {
				setGeolocation(position);
			});

			return;
		}
		setListShow(true);
	};

	const boxRef = useRef(null)
		useEffect(() =>{
			clickOutside(true,boxRef,()=>setListShow(false),"all")
			return (() =>clickOutside(false,boxRef,()=>setListShow(false),"all"))
		},[]);

	return (
		<CustomDropdownWrapper ref={boxRef}>
			<Input
				type={'search'}
				label={'Search operator'}
				name={'Search operator'}
				onChange={(e) => handleSearchChange(e)}
				value={searchQuery}
				onFocus={handalFocus}
				onBlur={blur}
				required={true}
			></Input>
			{/* <input type="text" placeholder="Search operator" value={searchQuery} onChange={handleSearchChange} onFocus={handalFocus} onBlur={blur} /> */}
			{listShow && list.length > 0 && (
				<div className="dropdown">
					{type === 'bill' && (
						<>
							{list
								.filter((option) => option.billerName.toLowerCase().startsWith(searchQuery.toLowerCase()))
								.map((option, index) => (
									<div
										key={index}
										className={isActive === option.billerName ? 'dropdown-option active' : 'dropdown-option'}
										onClick={() => handleOptionSelect(option.billerId, option.billerName)}
									>
										<div className="icons">
											{option?.iconUrl && <img src={option?.iconUrl} alt="operator-img" />}
										</div>
										<div className="name">{option.billerName}</div>
									</div>
								))}
						</>
					)}
					{type === 'mobile' && (
						<>
							{list
								.filter((option) => option.operatorName.toLowerCase().startsWith(searchQuery.toLowerCase()))
								.map((option, index) => (
									<div
										key={index}
										className={isActive === option.operatorName ? 'dropdown-option active' : 'dropdown-option'}
										onClick={() => handleOptionSelect(`${option?.operatorId},${option?.operatorCode}`, option?.operatorName)}
									>
										<div className="icons">
											<img src={option.operatorImage} alt="oprtator-imf" />
										</div>
										<div className="name">{option.operatorName}</div>
									</div>
								))}
						</>
					)}
				</div>
			)}
		</CustomDropdownWrapper>
	);
};

export default CustomDropdown;
